exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar ul li {\n  border-right: 1px solid;\n  display: inline;\n  font-size: 1.2rem;\n  padding: 0 1.5rem;\n  text-transform: uppercase; }\n  .navbar ul li:last-child {\n    border-right: 0; }\n\n@media (max-width: 640px) {\n  .navbar {\n    display: none; } }\n", ""]);

// exports
